import { Box, Typography } from "@mui/material";
import HeaderLabel from "component/CardCustom/HeaderLabel";
import { useTranslation } from "react-i18next";
import { routeName } from "routes/routes-name";

import ErrorOutlinedIcon from '@mui/icons-material/ErrorOutlined';
import { fileUrl } from "api/api";
import RegisterApi from "api/counter/register.api";
import TreatmentsAPI from 'api/dentists/treatment.api';
import HomeApi from "api/home/home.api";
import ClinicApi from "api/master/clinic.api";
import { resetModal, showModal } from "app/slice/modal.slice";
import { setDiagnosisByKey, setEditTootChart, setEditTootChartType, setToothChartSelected, setTreatmentByKey, treatment, TreatmentStateInterface } from "app/slice/treatment.slice";
import { selectMe } from "app/slice/user.slice";
import Loading from "component/Loading";
import { notiError, notiSuccess } from "component/notifications/notifications";
import BtnProfile from "component/Treatments/BtnProfile";
import PopupPatientDetail from "component/Treatments/PopupPatientDetail";
import { imgs } from "constants/images";
import IndexDoctorNote from "features/treatments/MainMenu/DoctorNote/Index";
import IndexImage from "features/treatments/MainMenu/Image/Index";
import IndexOPD from "features/treatments/MainMenu/OPD/Index";
import IndexVitalSign from "features/treatments/MainMenu/VitalSign/Index";
import IndexSummaryTreatment from "features/treatments/SummaryTreatment/Index";
import { DoctorsType, SUB_TABS_NAME, TabPanel, TABS_NAME } from "features/treatments/treatmentsIndex";
import * as TreatmentsUseStyled from 'features/treatments/UseStyle';
import * as UseStyled from 'features/treatments/UseStyle';
import _ from "lodash";
import MainButton from "new-components/buttons/main-button";
import AlertModal from "new-components/modal/alert-modal";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { getClinicInfo } from "utils/app.utils";

export default function EditNhsoTreatment() {
    const { t, i18n } = useTranslation()
    const location = useLocation()
    const history = useHistory()
    const branch = getClinicInfo()
    const dispatch = useDispatch()
    const user = useSelector(selectMe)
    const treatments: TreatmentStateInterface = useSelector(treatment)

    const [activeTab, setActiveTab] = useState<TABS_NAME>(TABS_NAME.OPD)
    const [activeSubTab, setActiveSubTab] = useState<SUB_TABS_NAME>(SUB_TABS_NAME.TX)
    const [subTabs, setSubTabs] = useState<SUB_TABS_NAME[]>([SUB_TABS_NAME.DX, SUB_TABS_NAME.TX])
    const footerTabs: string[] = ['TREATMENTS.FOOTER_TAB.SUMMARY_TREATMENT', 'TREATMENTS.FOOTER_TAB.DIAGNOSIS', 'TREATMENTS.FOOTER_TAB.RECOMMEND']
    const [isShowPopupDetail, setIsShowPopupDetail] = useState<boolean>(false)

    const [patientId, setPatientId] = useState(0)
    const [patientCaseId, setPatientCaseId] = useState(0)
    const [patient, setPatient]: any[] = useState([])
    const [dataPatientCase, setDataPatientCase] = useState<any>(null)
    const [doctors, setDoctors] = useState<DoctorsType[]>([])
    const [activeFooterTab, setActiveFooterTab] = useState(0)
    const [summaryTreatment, setSummeryTreatments] = useState<any>(null)
    const [patientDiagnosis, setPatientDiagnosis] = useState<any>(null)

    const [loading, setLoading] = useState(false)
    const [errorMessage, setErrorMessage] = useState<any>({
        teeth: '',
        note: ''
    })
    const [isOpenAlertModal, setIsOpenAlertModal] = useState(false)

    const handlePatientCode = () => {
        if (branch?.patientCodeQueue === '1') {
            return patient.cnNumber ?? ''
        }
        if (branch?.patientCodeQueue === '0') {
            return patient.branchCnNumber ?? ''
        }

        if (branch?.patientCodeQueue === '2') {
            return patient.snCode ?? ''
        }
    }

    const renderImage = (img: any) => {
        if (!_.isEmpty(img) && !_.isEmpty(img.filePath) && !_.isEmpty(img.fileName)) return `${fileUrl}/${img.filePath}/${img.fileName}`
        else return imgs.defaultAvatar
    }

    const loadPatient = async () => {
        if (patientId) {
            const patientData = await TreatmentsAPI.findPatient(patientId)
            if (patientData.status === 200 && !_.isEmpty(patientData.data)) {
                setPatient(patientData.data)
                // setImportantSymptoms(patientData.data.importantSymptoms)
                // setImportantSymptomsDoctor(patientData.data.importantSymptomsDoctor || '')
                // if (user?.position?.positionId === 2 && user?.autoShowPatientProfile === '1' && option?.viewPatient && ((disabledOpenPopupInfo && !_.includes(JSON.parse(disabledOpenPopupInfo), Number(patientId))) || !disabledOpenPopupInfo)) onViewHistory()
            } else setPatient([])
        }
    }

    const loadData = async (patientCaseId: number) => {
        try {
            setLoading(true)
            await HomeApi.patientCase(patientCaseId).then((resp) => {
                setDataPatientCase(resp.data)
            })
            const resp: any = await RegisterApi.getNhsoTreatmentById(patientCaseId)
            const toothChartSelected: any = []
            if (resp.status === 200) {
                dispatch(setTreatmentByKey({ key: 'summeryTreatments', value: resp.data?.summeryTreatments }))
                dispatch(setDiagnosisByKey({ key: 'patientDiagnosis', value: resp.data?.patientDiagnosis }))
                dispatch(setDiagnosisByKey({ key: 'patientRecommends', value: resp.data?.patientRecommends }))
            }
            _.map(resp.data?.summeryTreatments, (sum, index) => {
                toothChartSelected.push(JSON.parse(sum.teethJson))
            })
            await dispatch(setToothChartSelected(toothChartSelected))
        } catch (error) {
            setLoading(false)
        } finally {
            setLoading(false)
        }
    }

    const loadDoctor = async () => {
        const resp = await ClinicApi.findAllDoctors()
        if (resp.status === 200) setDoctors(resp.data)
    }

    useEffect(() => {
        loadDoctor()
    }, [])

    useEffect(() => {
        loadPatient()
    }, [patientId])

    useEffect(() => {
        if (patientCaseId !== 0) {
            loadData(patientCaseId)
        }
    }, [patientCaseId])

    useEffect(() => {
        const patientState: any = location.state
        // const valueServicePointId = getServicePoint()
        if (!_.isEmpty(patientState) && patientState.patientId && patientState?.patientCaseId) {
            setPatientId(patientState.patientId)
            setPatientCaseId(patientState.patientCaseId)
        }
    }, [location])

    const onCheckErrorSubmit = () => {
        const teethByIndex: Record<number, string> = {}
        const noteByIndex: Record<number, string> = {}
        treatments.summeryTreatments?.forEach((item: any, index: number) => {
            const needTooth = item?.requireTooth === '1' || item?.requireTooth === true
            const hasNoTeeth = !item?.teeth && !item?.teethJson
            if (needTooth && hasNoTeeth) {
                teethByIndex[index] = t('กรุณาเลือกซี่ฟัน')
            }
            if (!item?.note) {
                noteByIndex[index] = t('กรุณากรอกข้อมูลเพิ่มเติม')
            }
        })
        return { teeth: teethByIndex, note: noteByIndex }
    }

    const onEdit = async () => {
        try {
            setLoading(true)
            setIsOpenAlertModal(false)
            const resp: any = await RegisterApi.postNhsoTreatmentById(patientCaseId, {
                summeryTreatments: summaryTreatment,
                patientDiagnosis: patientDiagnosis
            })
            if (resp.data?.message?.length > 0) {
                notiError(t('แก้ไขรายการไม่สำเร็จ'))
            } else {
                if (resp.status === 201 && resp.data) {
                    notiSuccess('แก้ไขรายการสำเร็จ')
                    history.push(routeName.nhsoTreatment)
                } else {
                    notiError(t('ERROR'))
                }
            }


        } catch (error) {
            setLoading(false)
        } finally {
            setLoading(false)
        }
    }

    const checkErrorList = () => {
        const newError = onCheckErrorSubmit()
        const hasTeethError = Object.values(newError.teeth || {}).some(v => v !== '')
        const hasNoteError = Object.values(newError.note || {}).some(v => v !== '')
        if (hasTeethError || hasNoteError) {
            setErrorMessage(newError)
            setLoading(false)
            return
        }

        if (treatments.summeryTreatments.length === 0) {
            notiError('กรุณาเลือกรายการรักษา')
            return
        }

        if (treatments.patientDiagnosis.length === 0) {
            notiError('กรุณาเลือกรายการคำวินิจฉัย')
            return
        }

        const summeryTreatments: any = []
        const patientDiagnosis: any = []

        _.map(treatments.summeryTreatments, (i: any, index: number) => {
            summeryTreatments.push({
                orderIndex: typeof i?.orderIndex === 'number' ? i.orderIndex : index,
                orderTreatmentId: i?.orderTreatmentId || null,
                teeth: i?.teeth || null,
                teethJson: i?.teethJson || null,
                teethType: i?.teethType,
                operativeId: i?.operativeId || 0,
                qty: i?.qty || 0,
                price: i?.price || 0,
                doctorId: _.some(doctors, { 'userId': i.doctorId }) ? i.doctorId : 0,
                discount: i?.discount || 0,
                discountUnit: i?.discountUnit || "BAHT",
                additional: i?.additional || 0,
                additionalUnit: i?.additionalUnit || "BAHT",
                dfAmount: i?.dfAmount || null,
                dfUnit: i?.dfUnit || "BAHT",
                dfDiscountAmount: i?.dfDiscountAmount || 0,
                dfDiscountUnit: i?.dfDiscountUnit || "BAHT",
                dfAmountNet: i?.dfAmountNet || 0,
                cfAmount: i?.cfAmount || null,
                cfDiscountAmount: i?.cfDiscountAmount || 0,
                cfDiscountUnit: i?.cfDiscountUnit || "BAHT",
                cfAmountNet: i?.cfAmountNet || 0,
                dfRemark: i?.dfRemark || '',
                clinicFeeId: i?.clinicFeeId || null,
                total: i?.total || 0,
                note: i?.note || '',
                noteNextVisit: i?.noteNextVisit || '',
                refType: i?.refType || null,
                refId: i?.refId || 0,
                nextVisit: i?.nextVisit || null,
                commission: i?.commission || 0,
                promotionDiscount: i?.promotionDiscount || '',
                promotionDiscountUnit: i?.promotionDiscountUnit || "BAHT",
                dfPromotionDiscountAmount: i?.dfPromotionDiscountAmount || 0,
                dfPromotionDiscountUnit: i?.dfPromotionDiscountUnit || "BAHT",
                cfPromotionDiscountAmount: i?.cfPromotionDiscountAmount || 0,
                cfPromotionDiscountUnit: i?.cfPromotionDiscountUnit || "BAHT",
                voucherDiscount: i?.voucherDiscount || 0,
                voucherDiscountUnit: i?.voucherDiscountUnit || "BAHT",
                dfVoucherDiscountAmount: i?.dfVoucherDiscountAmount || 0,
                dfVoucherDiscountUnit: i?.dfVoucherDiscountUnit || "BAHT",
                cfVoucherDiscountAmount: i?.cfVoucherDiscountAmount || 0,
                cfVoucherDiscountUnit: i?.cfVoucherDiscountUnit || "BAHT"
            })
        })

        _.map(treatments.patientDiagnosis, (i: any, index: number) => {
            patientDiagnosis.push({
                diagnosisId: i?.diagnosisId || 0,
                doctorId: _.some(doctors, { userId: Number(i.doctorId) }) ? Number(i.doctorId) : 0,
                note: i?.note || "",
                teeth: i?.teeth || null,
                teethJson: i?.teethJson || null,
                teethType: i?.teethType || 'ADULT'
            })
        })

        if (_.some(summeryTreatments, { 'doctorId': 0 })) {
            setLoading(false)
            return notiError(t('TREATMENT_SUMMARY.MESSAGE.NO_DOCTOR_IN_TREATMENT'), '', null, null, 'register-page')
        }

        if (_.some(patientDiagnosis, { 'doctorId': 0 })) {
            setLoading(false)
            return notiError(t('TREATMENT_SUMMARY.MESSAGE.NO_DOCTOR_IN_DIAGNOSIS'), '', null, null, 'register-page')
        }

        setSummeryTreatments(summeryTreatments)
        setPatientDiagnosis(patientDiagnosis)

        setIsOpenAlertModal(true)
    }

    return (
        <Box>
            <Loading show={loading} />
            <AlertModal
                type='success'
                title='ยืนยันการส่งเบิก'
                message={`ระบบตรวจสอบรูปแบบการส่งถูกต้อง \nคุณยืนยันส่งเบิกการใช้สิทธิสปสช.ใน visit นี้ ใช่หรือไม่`}
                isOpen={isOpenAlertModal}
                handleClose={() => setIsOpenAlertModal(false)}
                onCancel={{ onClick: () => setIsOpenAlertModal(false) }}
                onSubmit={{ onClick: () => onEdit() }}
            />
            {isShowPopupDetail && (
                <PopupPatientDetail
                    isNotShownPhone={user.hasShowPhoneNumber === 'UNPERMISS'}
                    type='treatment'
                    profile={renderImage(patient.profile)}
                    patient={patient}
                    showPopup={isShowPopupDetail}
                    onClose={() => {
                        setIsShowPopupDetail(false)
                        dispatch(resetModal())
                    }}
                    reRenderPatient={() => loadPatient()}
                />
            )}
            <HeaderLabel
                text={'รายละเอียดการรักษา'}
                // goBack={routeName.incomeExpenses}
                // disabledSend={loading}
                // onSubmit={onSave}
                navigator={{
                    previousTo: routeName.nhsoTreatment,
                    previousTitle: t('จัดการข้อมูลย้อนหลังการรักษา (สิทธิ์ สปสช.)'),
                    currentTitle: t('รายละเอียดการรักษา')
                }}
                disabledSend
            />
            <Box paddingX="27px">
                <TreatmentsUseStyled.CardProfile className={`d-flex px-3 `} onClick={() => {
                    dispatch(showModal())
                    setIsShowPopupDetail(true)
                }}>
                    <BtnProfile profile={renderImage(patient.profile)} branchCnNumber={handlePatientCode()} firstName={patient.firstname} lastName={patient.lastname} rankId={patient.rankId} lastVisit={patient.updatedAt} />
                </TreatmentsUseStyled.CardProfile>

                <Box display="flex" flexDirection="row" alignItems="center" color="#B00020" fontSize="12px" fontWeight={400} gap="4px" paddingBottom="24px" paddingTop="12px">
                    <ErrorOutlinedIcon sx={{ fontSize: 13 }} />
                    <Typography>การเปิด visit โดยใช้สิทธิสปสช.จะสามารถเลือกรายการตามที่สปสช.กำหนดให้เท่านั้น</Typography>
                </Box>

                <Box>
                    <TabPanel value={activeTab} index={TABS_NAME.OPD}>
                        <IndexOPD
                            userId={user.userId}
                            type='Treatment'
                            activeTab={activeSubTab}
                            hasChangeProductDiscountAdditional={'PERMISS'}
                            hasChangeProductPrice={'PERMISS'}
                            hasCreateTreatment={'PERMISS'}
                            hasCreateTreatmentPlan={'PERMISS'}
                            hasCreateTreatmentCourse={'PERMISS'}
                            setActiveTab={(tab: SUB_TABS_NAME) => setActiveSubTab(tab)}
                            tabs={subTabs}
                            patient={patient}
                            dataPatientCase={dataPatientCase}
                            patientCaseId={patientCaseId}
                        />
                    </TabPanel>
                    <TabPanel value={activeTab} index={TABS_NAME.DOCTOR_NOTE}>
                        <IndexDoctorNote userId={user.userId} patient={patient} hasDoctorNote={'PERMISS'} hasCreateDoctorNote={'PERMISS'} hasDeleteDoctorNote={'PERMISS'} />
                    </TabPanel>
                    <TabPanel value={activeTab} index={TABS_NAME.IMAGE}>
                        <IndexImage patient={patient} />
                    </TabPanel>
                    <TabPanel value={activeTab} index={TABS_NAME.VITAL_SIGN}>
                        <IndexVitalSign patient={patient} onchange={setPatient} loadPatient={() => loadPatient()} />
                    </TabPanel>
                </Box>

                <IndexSummaryTreatment
                    // onSave={onSaveSummary}
                    // userId={user.userId}
                    type='Treatment'
                    tabs={footerTabs}
                    activeTab={activeFooterTab}
                    isNhso={dataPatientCase?.isNhso === '1'}
                    setActiveTab={(tab: number) => {
                        setActiveFooterTab(tab);
                        dispatch(setEditTootChart(null));
                        dispatch(setEditTootChartType(''));
                        if (tab === 0) setActiveSubTab(SUB_TABS_NAME.TX);
                        else if (tab === 1) setActiveSubTab(SUB_TABS_NAME.DX);
                    }}
                    hasTreatment={'PERMISS'}
                    hasChangeTreatmentCost={user?.hasChangeTreatmentCost || "PERMISS"}
                    hasChangeTreatmentNote={'PERMISS'}
                    hasChangeProductPrice={'PERMISS'}
                    patientCaseId={patient.patientCase?.patientCaseId}
                    patientId={patient.patientId}
                    patientName={`${patient.firstname} ${patient.lastname}`}
                    doctors={doctors}
                    hasDiagnosis={'PERMISS'}
                    hasChangeProductDiscountAdditional={'PERMISS'}
                    hasDeleteTreatment={'PERMISS'}
                    patientPhone={patient.phone}
                    // handleTreatmentCurrent={setTreatmentCurrent}
                    errorMessage={errorMessage}
                />

                <Box paddingTop="80px">
                    <UseStyled.FooterAction className={`d-flex align-items-center justify-content-between position-fixed px-3 px-md-4`}>
                        <Box></Box>
                        <MainButton title="บันทึกการแก้ไข" type="primary" variant="contained" onClick={() => checkErrorList()} />
                    </UseStyled.FooterAction>
                </Box>
            </Box>
        </Box>
    )
}